<template src='./index.html'></template>
<script>
import rcsz from './rcsz/index.vue';
import jqsz from './jqsz/index.vue';
import { getdata } from './data.js';
import { ywlxgz_bcywgz, ywlxgz_bjcx, ywlxgz_cxdclf, ywlxgz_ywlxquery } from '@/api/ywlxgz';

export default {
    name: 'ywlxzt_ywgz_xjgz',
    components: {
        rcsz, // 容差设置弹框
        jqsz // 截取设置弹框
    },
    props: {
        xjgzdialog: {
            type: Boolean,
            default: false
        },
        wikiType: {
            type: String,
            default: ''
        },
        dialogTitle: {
            type: String,
            default: ''
        },
        formData: {
            type: Object,
            default: {}
        },
        pageType: {
            type: String,
            default: ''
        }
    },
    watch: {
        wikiType: function(indexVal, oldVal) {
            if (indexVal) {
                this.$nextTick(function() {
                    if (this.pageType === '0') {
                        // 业务类型管理页面
                        if (this.wikiType !== '-1') {
                            // 新建或编辑加载业务类型, 此处保证弹框才发起请求
                            this.loadBsType();
                        }
                        if (this.wikiType === '0') {
                            // 新建页面,
                            this.init();
                        } else if (this.wikiType === '1' || this.wikiType === '2') {
                            // 编辑页面
                            this.editLoadData();
                        }
                    } else if (this.pageType === '1') {
                        // TODO 即征即退规则页面
                        if (this.wikiType !== '-1') {
                            // 新建或编辑加载分摊方式, 此处保证弹框才发起请求
                            this.loadSharingType()
                        }
                        if (this.wikiType === '0') {
                            // 新建页面
                        } else if (this.wikiType === '1') {
                            // 编辑页面
                        }
                    }
                });
            }
        }
    },
    data: function() {
        return {
            form: getdata().formData,
            logic: '0',
            groupData: getdata().groupData,
            fpField: [],
            pzField: [],
            jqFormData: [],
            rcFormData: [],
            rcszdialog: false,
            jqszdialog: false,
            strOpTypes: getdata().strOpTypes,
            numOpTypes: getdata().numOpTypes,
            bsTypes: [],
            bsTitle: '',
            conditionRuleIndex: 0,
            conditionGroupIndex: 0,
            toleranceRuleIndex: 0,
            toleranceGroupIndex: 0,
            dealVoucherFlag: false, // 待处理方凭证
            dealInvoiceFlag: false, // 待处理方发票
            conditionsVoucherFlag: false, // 满足条件凭证
            conditionsInvoiceFlag: false, // 满足条件发票
            invoiceOrVoucherFlag: false, // 发票或凭证
            invoiceAndVoucherFlag: false, // 发票 + 凭证
            rules: {
                name: [
                    { required: true, message: '请输入规则名称', trigger: 'blur' }
                ],
                level: [
                    { required: true, message: '请选择优先级', trigger: 'blur' }
                ]
            }
        };
    },
    mounted() {
        if (this.pageType === '0') {
            this.bsTitle = '请选择业务类型';
        } else if (this.pageType === '1') {
            this.bsTitle = '请选择分摊方式';
        }
    },
    created() {
    },
    computed: {
        executeActionValue: {
            get() {
                return this.pageType==='0' ? this.form.executeAction : this.form.test;
            },
            set(newValue) {
                if (this.pageType==='0') {
                    // 业务类型规则页面
                    this.form.executeAction = newValue;
                } else if (this.pageType==='1') {
                    // 即征即退规则页面
                    this.form.test = newValue;
                }
            }
        }
    },
    methods: {
        ruleDetailChange(e) {
            if (this.pageType === '0') {
                // 业务类型管理页面
                let items = this.bsTypes.filter(item => item.value === e);
                let resRange = items[0].resRange;
                if (!resRange) {
                    this.$message.error("规则异常，该规则取值范围为空");
                    return;
                }
                this.groupData.forEach(item => {
                    item.data.forEach(rule => {
                        if (rule.mainFieldClass) {
                            rule.mainFieldClass = "";
                        }
                        if (rule.secondaryClass) {
                            rule.secondaryClass = "";
                        }
                        switch (resRange) {
                            case "1":
                                // 仅发票
                                rule.dealInvoiceFlag = false;
                                rule.conditionsInvoiceFlag = false;
                                rule.dealVoucherFlag = true;
                                rule.conditionsVoucherFlag = true;
                                rule.invoiceOrVoucherFlag = false;
                                rule.invoiceAndVoucherFlag = false;
                                this.dealInvoiceFlag = false;
                                this.conditionsInvoiceFlag = false;
                                this.dealVoucherFlag = true;
                                this.conditionsVoucherFlag = true;
                                this.invoiceOrVoucherFlag = false;
                                this.invoiceAndVoucherFlag = false;
                                break;
                            case "2":
                                // 仅凭证
                                rule.dealInvoiceFlag = true;
                                rule.conditionsInvoiceFlag = true;
                                rule.dealVoucherFlag = false;
                                rule.conditionsVoucherFlag = false;
                                rule.invoiceOrVoucherFlag = false;
                                rule.invoiceAndVoucherFlag = false;
                                this.dealInvoiceFlag = true;
                                this.conditionsInvoiceFlag = true;
                                this.dealVoucherFlag = false;
                                this.conditionsVoucherFlag = false;
                                this.invoiceOrVoucherFlag = false;
                                this.invoiceAndVoucherFlag = false;
                                break;
                            case "3":
                                // 发票 + 凭证
                                rule.dealInvoiceFlag = false;
                                rule.conditionsInvoiceFlag = true;
                                rule.dealVoucherFlag = false;
                                rule.conditionsVoucherFlag = true;
                                rule.invoiceOrVoucherFlag = false;
                                rule.invoiceAndVoucherFlag = true;
                                this.dealInvoiceFlag = false;
                                this.conditionsInvoiceFlag = true;
                                this.dealVoucherFlag = false;
                                this.conditionsVoucherFlag = true;
                                this.invoiceOrVoucherFlag = false;
                                this.invoiceAndVoucherFlag = true;
                                break;
                            case "4":
                                // 仅发票 / 仅凭证
                                rule.dealInvoiceFlag = false;
                                rule.conditionsInvoiceFlag = true;
                                rule.dealVoucherFlag = false;
                                rule.conditionsVoucherFlag = true;
                                rule.invoiceOrVoucherFlag = true;
                                rule.invoiceAndVoucherFlag = false;
                                this.dealInvoiceFlag = false;
                                this.conditionsInvoiceFlag = true;
                                this.dealVoucherFlag = false;
                                this.conditionsVoucherFlag = true;
                                this.invoiceOrVoucherFlag = true;
                                this.invoiceAndVoucherFlag = false;
                                break;
                        }
                    })
                })
            }
        },
        init() {
            // 初始化规则组和表单数据
            this.groupData = getdata().groupData;
            this.form = getdata().formData;
            this.dealInvoiceFlag = false;
            this.conditionsInvoiceFlag = false;
            this.dealVoucherFlag = false;
            this.conditionsVoucherFlag = false;
            this.invoiceOrVoucherFlag = false;
            this.invoiceAndVoucherFlag = false;
        },
        editLoadData() {
            ywlxgz_bjcx({ id: this.formData.id }).then(res => {
                if (res.data.code === '1') {
                    this.form = res.data.data;
                    this.logic = res.data.data.logic;
                    if (res.data.data.enable === '1') {
                        this.form.enable = true;
                    } else {
                        this.form.enable = false;
                    }
                    let gpData = res.data.data.data;
                    if (gpData && gpData.length > 0) {
                        gpData.forEach(gpItem => {
                            if (gpItem.data && gpItem.data.length > 0) {
                                gpItem.data.forEach(item => {
                                    if (item.mainFieldClass) {
                                        if (item.mainFieldClass === '0') {
                                            // 选中发票
                                            item.dealField = this.fpField;
                                        } else if (item.mainFieldClass === '1') {
                                            // 选中凭证
                                            item.dealField = this.pzField;
                                        }
                                        let fieldType = item.dealField.filter(dealItem => dealItem.value === item.mainFieldName).map(item => item.fieldType);
                                        if (fieldType[0] === 'String') {
                                            item.opTypes = this.strOpTypes;
                                        } else {
                                            item.opTypes = this.numOpTypes;
                                        }
                                    }
                                    if (item.secondaryClass) {
                                        if (item.secondaryClass === '0') {
                                            // 选中发票
                                            item.conditionField = this.fpField;
                                        } else if (item.secondaryClass === '1') {
                                            // 选中凭证
                                            item.conditionField = this.pzField;
                                        }
                                    }
                                  //拼接描述
                                  item.rule = ""
                                  let fieldType = '';
                                  if (item.mainFieldClass === '1') {
                                    // 凭证
                                    fieldType = this.pzField.filter(item2 => item2.value === item.mainFieldName).map(item2 => item2.fieldType);
                                  } else if (item.mainFieldClass === '0') {
                                    // 发票
                                    fieldType = this.fpField.filter(item2 => item2.value === item.mainFieldName).map(item2 => item2.fieldType);
                                  }
                                  if (fieldType && fieldType.length > 0) {
                                    if (fieldType[0] === 'String') {
                                      // 截取
                                      item.rule += "待处理方：";
                                      item.toleranceDTOS.filter(v => v.interceptType === "1").forEach(v => {
                                        if (v.mode === "00") {
                                          item.rule += "开始字符[" + v.startValue + "]至结束字符[" + v.endValue + "]；";
                                        } else if (v.mode === "01") {
                                          item.rule += "开始字符[" + v.startValue + "]后" + v.formatLength + "个字符；";
                                        }
                                      })
                                      item.rule += "匹配对象：";
                                      item.toleranceDTOS.filter(v => v.interceptType === "2").forEach(v => {
                                        item.rule += jqsz.data().rangeData.filter(item => item.value === v.mode)[0].label + " ";
                                        if (v.mode === "00") {
                                          item.rule += "开始字符[" + v.startValue + "]至结束字符[" + v.endValue + "]；";
                                        } else if (v.mode === "01") {
                                          item.rule += "开始字符[" + v.startValue + "]后" + v.formatLength + "个字符；";
                                        }
                                      })
                                    } else {
                                      // 容差
                                      item.toleranceDTOS.forEach(v => {
                                        if (v.mode === "05") {
                                          item.rule += "固定值：[" + v.startValue + "]至[" + v.endValue + "]；";
                                        } else if (v.mode === "04") {
                                          item.rule += "固定精度：[" + rcsz.data().rangeTypes.filter(item => item.value === v.roundingType)[0].label + "]请精确到小数点后[" + v.formatLength + "]位；";
                                        } else if (v.mode === "03") {
                                          item.rule += "百分比：[" + v.startValue + "%]至[" + v.endValue + "%]；";
                                        }
                                      })
                                    }
                                  }
                                });
                            }
                        });
                    }
                    this.groupData = gpData;
                }
            });
        },
        loadBsType() {
            let params = {resRange: "-1", bsType: "1"};
            ywlxgz_ywlxquery(params).then(res => {
                if (res.data.code === '1') {
                    this.bsTypes = res.data.data;
                }
            });
            // 查询发票对应的属性
            ywlxgz_cxdclf({ type: '0' }).then(res => {
                if (res.data.code === '1') {
                    this.fpField = res.data.data;
                }
            });
            // 查询凭证对应的属性
            ywlxgz_cxdclf({ type: '1' }).then(res => {
                if (res.data.code === '1') {
                    this.pzField = res.data.data;
                }
            });
        },
        loadSharingType() {
            // 加载分摊方式
            this.bsTypes = [
                { label: '全额分摊', value: '1' },
                { label: '按销售额比例分摊', value: '2' },
                { label: '按实际成本分摊', value: '3' },
                { label: '暂不分摊', value: '4' }
            ];
        },
        closediag() {
            this.$emit('closediag', false);
            if (this.wikiType === '0') {
                // 新建页面
                this.init();
            }
        },
        saveRule() {
            let params = this.form;
            if (!params.name) {
                this.$message.error("规则名称必填");
                return;
            }if (!params.level || params.level === '0') {
                this.$message.error("优先级必填且不能为0");
                return;
            }
            params.bsType = this.formData.bsType;
            params.setofbooksId = this.formData.setofbooksId;
            if (params.enable) {
                params.enable = '1';
            } else {
                params.enable = '0';
            }
            params.logic = this.logic;
            params.groupDTOS = [];
            if (this.wikiType === '1') {
                params.id = this.formData.id;
            }
            this.groupData.forEach(item => {
                let groupData = {};
                groupData.logic = item.logic;
                groupData.conditionDTOS = item.data;
                params.groupDTOS.push(groupData);
            });
            ywlxgz_bcywgz(JSON.stringify(params)).then(res => {
                if (res.data.code === '1') {
                    this.$message.success('操作成功！');
                    this.$emit('closediag', false);
                    this.init();
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        deleteGroup(groupIndex) {
            this.groupData = this.groupData.filter(item => item.index !== groupIndex);
        },
        addGroup() {
            if (this.groupData.length === 0) {
                // 没有规则组
                this.groupData.push([{ index: 1, data: [{ index: 1 }], logic: '0' }]);
            } else {
                let index = this.groupData[this.groupData.length - 1].index + 1;
                let data = { index: index, data: [{ index: 1, dealInvoiceFlag: this.dealInvoiceFlag,
                        dealVoucherFlag: this.dealVoucherFlag,
                        conditionsInvoiceFlag: this.conditionsInvoiceFlag,
                        conditionsVoucherFlag: this.conditionsVoucherFlag,
                        invoiceOrVoucherFlag: this.invoiceOrVoucherFlag,
                        invoiceAndVoucherFlag: this.invoiceAndVoucherFlag,}], logic: '0' };
                this.groupData.push(data);
            }
        },
        addRule(groupIndex) {
            let groupDatum = this.groupData.filter(item => item.index === groupIndex);
            groupDatum[0].data.push({ index: groupDatum[0].data[groupDatum[0].data.length - 1].index + 1,
                dealInvoiceFlag: this.dealInvoiceFlag,
                dealVoucherFlag: this.dealVoucherFlag,
                conditionsInvoiceFlag: this.conditionsInvoiceFlag,
                conditionsVoucherFlag: this.conditionsVoucherFlag,
                invoiceOrVoucherFlag: this.invoiceOrVoucherFlag,
                invoiceAndVoucherFlag: this.invoiceAndVoucherFlag,});
        },
        deleteRule(groupIndex, ruleIndex) {
            let groups = this.groupData.filter(item => item.index === groupIndex);
            if (groups && groups.length > 0) {
                if (groups[0].data.length === 1) {
                    this.$message.error('当前规则组只有一条规则，不允许删除');
                    return;
                }
                groups[0].data = groups[0].data.filter(item => item.index !== ruleIndex);
            }
        },
        groupChange() {
            if (this.logic === '0') {
                this.logic = '1';
            } else if (this.logic === '1') {
                this.logic = '0';
            }
        },
        ruleChange(group) {
            if (group.logic === '0') {
                group.logic = '1';
            } else if (group.logic === '1') {
                group.logic = '0';
            }
        },
        conditionSetting(rule, group) {
            let fieldType = '';
            if (rule.mainFieldClass === '1') {
                // 凭证
                fieldType = this.pzField.filter(item => item.value === rule.mainFieldName).map(item => item.fieldType);
            } else if (rule.mainFieldClass === '0') {
                // 发票
                fieldType = this.fpField.filter(item => item.value === rule.mainFieldName).map(item => item.fieldType);
            }
            if (fieldType && fieldType.length > 0) {
                if (fieldType[0] === 'String') {
                    // 截取
                    this.jqszdialog = true;
                    this.rcszdialog = false;
                    this.conditionRuleIndex = rule.index;
                    this.conditionGroupIndex = group.index;
                    if (rule.toleranceDTOS) {
                        this.jqFormData = rule.toleranceDTOS;
                    }
                } else {
                    // 容差
                    this.jqszdialog = false;
                    this.rcszdialog = true;
                    this.toleranceRuleIndex = rule.index;
                    this.toleranceGroupIndex = group.index;
                    if (rule.toleranceDTOS) {
                        this.rcFormData = rule.toleranceDTOS;
                    }
                }
            } else {
                this.$message.error('请先选中处理方字段，再进行容差设置');
            }
        },
        rcszclosediag() {
            this.rcszdialog = false;
            this.rcFormData = [];
            if (this.$refs.rcszObj.saveClickFlag) {
                // 子组件点击保存时才对其进行赋值操作
                let groups = this.groupData.filter(item => item.index === this.toleranceGroupIndex);
                if (groups && groups.length > 0) {
                    let rules = groups[0].data.filter(item => item.index === this.toleranceRuleIndex);
                    if (rules && rules.length > 0) {
                        rules[0].toleranceDTOS = this.$refs.rcszObj.rcszData;
                        rules[0].rule = this.$refs.rcszObj.rcszDesc;
                    }
                }
            }
            this.$refs.rcszObj.saveClickFlag = false; // 初始化点击变量
        },
        jqszclosediag() {
            this.jqszdialog = false;
            this.jqFormData = [];
            if (this.$refs.jqszObj.saveClickFlag) {
                // 子组件点击保存时才对其进行赋值操作
                let groups = this.groupData.filter(item => item.index === this.conditionGroupIndex);
                if (groups && groups.length > 0) {
                    let rules = groups[0].data.filter(item => item.index === this.conditionRuleIndex);
                    if (rules && rules.length > 0) {
                        rules[0].toleranceDTOS = this.$refs.jqszObj.jqszData;
                        rules[0].rule = this.$refs.jqszObj.jqszDesc;
                    }
                }
            }
            this.$refs.jqszObj.saveClickFlag = false; // 初始化点击变量
        },
        dealTypeChange(rule) {
            if (!this.executeActionValue) {
                rule.mainFieldClass = "";
                this.$message.error('请先选择规则明细，再进行条件配置');
                return;
            }
            if (rule.invoiceOrVoucherFlag) {
                // 仅发票 / 仅凭证
                if (rule.mainFieldClass === '0') {
                    // 选择发票
                    rule.conditionsInvoiceFlag = false;
                    rule.conditionsVoucherFlag = true;
                } else if (rule.mainFieldClass === '1') {
                    // 选择凭证
                    rule.conditionsInvoiceFlag = true;
                    rule.conditionsVoucherFlag = false;
                }
            } else if (rule.invoiceAndVoucherFlag) {
                // 发票 + 凭证
                if (rule.mainFieldClass === '0') {
                    // 选择发票
                    rule.conditionsInvoiceFlag = true;
                    rule.conditionsVoucherFlag = false;
                } else if (rule.mainFieldClass === '1') {
                    // 选择凭证
                    rule.conditionsInvoiceFlag = false;
                    rule.conditionsVoucherFlag = true;
                }
            }
            // 切换待处理方，清空选中的字段
            if (rule.mainFieldName) {
                rule.mainFieldName = '';
            }
            // 查询对应的属性
            if (rule.mainFieldClass === '1') {
                rule.dealField = this.pzField;
            } else if (rule.mainFieldClass === '0') {
                rule.dealField = this.fpField;
            }
        },
        conditionTypeChange(rule) {
            if (!this.executeActionValue) {
                rule.secondaryClass = "";
                this.$message.error('请先选择规则明细，再进行条件配置');
                return;
            }
            // 切换待处理方，清空选中的字段
            if (rule.secondaryFieldName) {
                rule.secondaryFieldName = '';
            }
            if (rule.value) {
                rule.value = '';
            }
            if (rule.secondaryClass !== 2) {
                // 查询对应的属性
                if (rule.secondaryClass === '1') {
                    rule.conditionField = this.pzField;
                } else if (rule.secondaryClass === '0') {
                    rule.conditionField = this.fpField;
                }
            } else {
                // 固定值
            }
        },
        dealFieldChange(rule) {
            let fieldType = rule.dealField.filter(item => item.value === rule.mainFieldName).map(item => item.fieldType);
            if (fieldType && fieldType.length > 0) {
                if (fieldType[0] === 'String') {
                    rule.opTypes = this.strOpTypes;
                } else {
                    rule.opTypes = this.numOpTypes;
                }
            }
        }
    }
};
</script>

<style scoped lang='less'>
@import url('./index.less');
</style>
